module.exports = __webpack_public_path__ + "img/cta-dosing-bg-1.d9e395ea.png";